/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from "mobx-react";
import React, { useEffect, memo, useState } from "react";
import { useStore } from "app/stores";
import { useTranslation } from "react-i18next";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import CreateOrUpdateFolder from "./Popup/CreateOrUpdateFolder";
import PatientListFolder from "./Component/PatientListFolder";
import ImageListByDate from "./Component/ImageListByDate";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import { getDate } from "app/common/LocalFunction";

function ImageGeneralTabIndex() {
  const { t } = useTranslation();

  const {
    handleClosePopup,
    handleLoadFirstPatientFolder,
    folderSelected,
    openFormCreateOrEditFolder,
    saveOrUpdatePatientFolder,

    handleConfirmDeleteByDate,
    openConfirmDeleteByDate,
    handleCloseConfirmDeleteByDate,
    openConfirmDeleteAllDate,
    handleCloseConfirmDeleteAllDate,
    handleConfirmDeleteAllDate,
    handleDeleteSingleImage,
    handleCloseConfirmSingleImage,
    openConfirmDeleteSingleImage,
    resetStore,
  } = useStore().patientManagementStore.imageGeneralTabStore;

  const { initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  useEffect(() => {
    handleLoadFirstPatientFolder({ patientId });
    return () => resetStore();
  }, []);

  return (
    <section className="file-manager-container">
      <Grid container spacing={1} className="p-1">
        {/* Sidebar Folder */}
        <Grid item xs={12} md={3}>
          <PatientListFolder
            isMobile={isMobile}
            patient={initialPatient.patientInfo}
          />
        </Grid>

        {/* Main Content */}
        <Grid item xs={12} md={9}>
          <ImageListByDate patientId={patientId} isMobile={isMobile} />
        </Grid>
      </Grid>
      <CreateOrUpdateFolder
        handleClose={handleClosePopup}
        handleSubmit={saveOrUpdatePatientFolder}
        initialValues={folderSelected}
        open={openFormCreateOrEditFolder}
        patientId={patientId}
      />

      <ConfirmPopup
        open={openConfirmDeleteByDate}
        onClose={handleCloseConfirmDeleteByDate}
        text={t(
          `Bạn có chắc chắn muốn xóa ảnh ngày ${getDate(
            openConfirmDeleteByDate
          )}?`
        )}
        onConfirm={() => handleConfirmDeleteByDate({ patientId })}
      />

      <ConfirmPopup
        open={openConfirmDeleteAllDate}
        onClose={handleCloseConfirmDeleteAllDate}
        text={t("Bạn có chắc chắn muốn xóa tất cả ảnh trong thư mục này?")}
        onConfirm={() => handleConfirmDeleteAllDate({ patientId })}
      />

      <ConfirmPopup
        open={openConfirmDeleteSingleImage}
        onClose={handleCloseConfirmSingleImage}
        text={t("Bạn có chắc chắn muốn xóa ảnh này?")}
        onConfirm={() => handleDeleteSingleImage({ patientId })}
      />
    </section>
  );
}

export default memo(observer(ImageGeneralTabIndex));
